import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import CustomerAttributes from '@/components/CustomerAttributes'
import ElasticStatus from '@/components/ElasticStatus'
import About from '@/components/About'
import Privacy from '@/components/Privacy'
import CmsTransfer from '@/components/CmsTransfer'

Vue.use(Router)

const routes = [
  {
    path: '/',
    name: 'HelloWorld',
    component: HelloWorld,
    meta: {
      title: 'Rees Solutions',
      metaTags: [
        {
          name: 'description',
          content: 'Rees Solutions: Web Development & Magento Extensions'
        },
        {
          property: 'og:description',
          content: 'Rees Solutions: Web Development & Magento Extensions'
        }
      ]
    }
  },
  {
    path: '/customer-attributes',
    name: 'CustomerAttributes',
    component: CustomerAttributes,
    meta: {
      title: 'Customer Attributes Magento 2 Extension',
      metaTags: [
        {
          name: 'description',
          content: 'The Rees Solutions Customer Attributes Magento 2 Extension by Rees Solutions.'
        },
        {
          property: 'og:description',
          content: 'The Rees Solutions Customer Attributes Magento 2 Extension by Rees Solutions.'
        }
      ]
    }
  },
  {
    path: '/cms-transfer',
    name: 'CmsTransfer',
    component: CmsTransfer,
    meta: {
      title: 'CmsTransfer Magento 2 Extension',
      metaTags: [
        {
          name: 'description',
          content: 'The Rees Solutions CmsTransfer Magento 2 Extension by Rees Solutions.'
        },
        {
          property: 'og:description',
          content: 'The Rees Solutions CmsTransfer Magento 2 Extension by Rees Solutions.'
        }
      ]
    }
  },
  {
    path: '/elastic-status',
    name: 'ElasticStatus',
    component: ElasticStatus,
    meta: {
      title: 'Elastic Status Magento 2 Extension',
      metaTags: [
        {
          name: 'description',
          content: 'The Rees Solutions Elastic Status Magento 2 Extension by Rees Solutions.'
        },
        {
          property: 'og:description',
          content: 'The Rees Solutions Elastic Status Magento 2 Extension by Rees Solutions.'
        }
      ]
    }
  },
  {
    path: '/about',
    name: 'About',
    component: About,
    meta: {
      title: 'About Us',
      metaTags: [
        {
          name: 'description',
          content: 'About Rees Solutions.'
        },
        {
          property: 'og:description',
          content: 'About Rees Solutions.'
        }
      ]
    }
  },
  {
    path: '/privacy-notice',
    name: 'Privacy',
    component: Privacy,
    meta: {
      title: 'Privacy Notice',
      metaTags: [
        {
          name: 'description',
          content: 'Rees Solutions Privacy Notice'
        },
        {
          property: 'og:description',
          content: 'Rees Solutions Privacy Notice'
        }
      ]
    }
  }
]

const router = new Router({
  mode: 'history',
  routes
})

// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // e.g., if we have `/some/deep/nested/route` and `/some`, `/deep`, and `/nested` have titles,
  // `/nested`'s will be chosen.
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title)

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags)

  const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags)

  // If a route with a title was found, set the document (page) title to that value.
  if (nearestWithTitle) {
    document.title = nearestWithTitle.meta.title
  } else if (previousNearestWithMeta) {
    document.title = previousNearestWithMeta.meta.title
  }

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el))

  // Skip rendering meta tags if there are none.
  if (!nearestWithMeta) return next()

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags.map(tagDef => {
    const tag = document.createElement('meta')

    Object.keys(tagDef).forEach(key => {
      tag.setAttribute(key, tagDef[key])
    })

    // We use this to track which meta tags we create so we don't interfere with other ones.
    tag.setAttribute('data-vue-router-controlled', '')

    return tag
  })
  // Add the meta tags to the document head.
    .forEach(tag => document.head.appendChild(tag))

  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js